const NotFound = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-slate-900 text-white text-5xl font-extrabold">
      Page Not Found
    </div>
  );
};

export default NotFound;
